export default __webpack_public_path__ + "static/media/img-4.1ef3a9e7.jpg";